document.addEventListener('algolia.hooks.initialize', function() {
  algoliaShopify.hooks.registerHook('afterISStartRemoveDefaultWidget', function(defaultWidgets) {
    console.log(defaultWidgets);
    // Find 'ais.hits'
    const hitsWidget = defaultWidgets.find(
      widget => widget.$$widgetType === 'ais.hits'
    );
    // Find 'ais.pagination'
    const paginationWidget = defaultWidgets.find(
      widget => widget.$$widgetType === 'ais.pagination'
    );
    return [hitsWidget, paginationWidget];
  });
  const { infiniteHits } = window.instantsearch.widgets;
  algoliaShopify.hooks.registerHook('beforeISStartAddWidgetArray', function() {
    const infiniteHitsWidget = infiniteHits({
      container: '.ais-hits-container',
      templates: {
        item(hit, { html, components }) {
          return window.algoliaShopify.instantsearch.templates.instantSearchProductTemplate(
            hit,
            html,
            components,
            window.algoliaShopify
          );
        },
        empty(results, { html }) {
          return window.algoliaShopify.instantsearch.templates.instantSearchNoResultTemplate(
            html,
            window.algoliaShopify
          );
        },
      },
      transformItems: items => {
        const transformItems = items.map(item => ({
          ...item,
          _distinct: window.algoliaShopify.instantsearch.distinct,
          can_order: item.inventory_policy === 'continue' || item.inventory_quantity > 0,
          queryID: item.__queryID,
          productPosition: item.__position,
          index: window.algoliaShopify.instantsearch.search.mainIndex.getIndexName(),
        }));
        return transformItems;
      },
    });
    return [infiniteHitsWidget];
  });
  algoliaShopify.hooks.registerHook('beforeInstantSearchMainTemplate', function(_defaultTemplate, data, html) {
    return html`
      <div class="ais-page">
        <div class="ais-input">
          <div class="ais-search-box-container"></div>
          <div class="ais-input-button">
            <div class="ais-clear-input-icon"></div>
          </div>
        </div>
        <div class="ais-facets-button">
          Show filters
        </div>
        <div class="ais-block">
          <div class="ais-search-header">
            <div class="ais-stats-container"></div>
            <div class="ais-change-display">
              <span class="ais-change-display-block ais-change-display-selected"
                ><i class="fa fa-th-large"></i
              ></span>
              <span class="ais-change-display-list"
                ><i class="fa fa-th-list"></i
              ></span>
            </div>
            <div class="ais-right-search-header-container">
              <details class="ais-filter-activator" id="Details-algolia-1">
                <summary class="summaryAlgolia">
                  <span>
                    <span>
                      <strong>
                        Filter
                      </strong>
                    </span>
                  </span>
                  <span tabindex="0" class="mobile-facets__close mobile-facets__close--no-js"><span class="algolia_close_filter"></span></span>
                </summary>
                <div class="ais-facets">
                  <div class="ais-clear-refinements-container"></div>
                  <div class="ais-current-refined-values-container"></div>
                  ${data.facets.map(
                    facet =>
                      html`
                        <div class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}">
                          <label
                            for="${facet.escapedName}"
                            class="ais-range-slider--header ais-facet--header ais-header"
                            >${facet.title}</label
                          >
                          <input
                            class="ais-dropdown-checkbox"
                            type="checkbox"
                            id="${facet.escapedName}"
                            name="dropdown"
                          />
                          <div class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"></div>
                        </div>
                      `
                  )}
                </div>
              </details>
              <div class="ais-sort">
                ${data.multipleSortOrders
                  ? html`
                      ${algoliaShopify.translations.sortBy}
                      <span class="ais-sort-orders-container"></span>
                    `
                  : html`
                      ${algoliaShopify.translations.sortBy}
                      ${algoliaShopify.translations.relevance}
                    `}
              </div>
            </div>
          </div>
          <div class="ais-hits-container ais-results-as-block"></div>
        </div>
        <div class="ais-pagination-container"></div>
      </div>
      <script>
        function addOverflowHidden() {
          if (document.body.classList.contains("overflow-hidden")) {
            document.body.classList.remove("overflow-hidden");
          } else {
            document.body.classList.add("overflow-hidden");
          }
        }
        const algoliaDetails = document.getElementById("Details-algolia-1");
        const algoliaSum = algoliaDetails.querySelector("summary");
        algoliaSum.addEventListener("click", () => {
          addOverflowHidden();
        });
      </script>
    `
  });
  algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', function(_defaultTemplate, hit, html, components) {
    let newin = null;
    if (hit.meta.custom.new_prod == "newin") {
      newin = hit.meta.custom.new_prod.substring(0, 3);
    } else {
      newin = null;
    }
    return html`
      <div
        class="ais-hit ais-product"
        data-algolia-index="${hit.index}"
        data-algolia-position="${hit.productPosition}"
        data-algolia-queryid="${hit.queryID}"
        data-algolia-objectid="${hit.objectID}"
        data-handle="${hit.handle}"
        data-variant-id="${hit.objectID}"
        data-distinct="${hit._distinct}"
        data-product-id="${hit.id}"
        onClick="${() => algoliaShopify.helpers.handleItemClick(hit)}"
      >
        <div class="ais-hit--mediaContainer">
          <div class="ais-image-overlay">
            <div class="news__badge">
              <span class="newin_elm">${newin}</span>
            </div>
            <div class="card__badge top left">
              <span class="ais-hit--price-discount badge badge--bottom-left"
                >${algoliaShopify.helpers.displayDiscount(
                  hit.price,
                  hit.compare_at_price,
                  hit.price_ratio
                ).replace("- ", "")}</span
              >
            </div>
          </div>
          <img
            class="ais-hit--picture"
            src="${hit.image}"
            alt="${hit.title} - ${hit.variant_title}"
          />
        </div>
        <div class="ais-hit--details">
          <div class="prod_mat_tags">
            <p class="ais-hit--meta prod_mat_tag">
              ${hit.meta.custom.product_material_certifications}
            </p>
          </div>
          <p class="ais-hit--title">
            <a
              data-algolia-index="${hit.index}"
              data-algolia-position="${hit.productPosition}"
              data-algolia-queryid="${hit.queryID}"
              data-algolia-objectid="${hit.objectID}"
              href="${algoliaShopify.helpers.instantsearchLink(hit)}"
              title="${algoliaShopify.helpers.fullTitle(
                hit.title,
                hit._distinct,
                hit.variant_title
              )}"
            >
              ${components.Highlight({ attribute: 'title', hit })}
              ${algoliaShopify.helpers.variantTitleAddition(hit, hit._distinct)}
            </a>
          </p>
          <p class="ais-hit--price">
            <b>${algoliaShopify.helpers.displayPrice(hit, hit._distinct)}</b>
            <span class="ais-hit--price-striked"
              ><span
                >${algoliaShopify.helpers.displayStrikedPrice(
                  hit.price,
                  hit.compare_at_price
                )}</span
              ></span
            >
            ${!hit._distinct &&
              html`
                <span class="ais-hit--price-striked"
                  ><span
                    >${algoliaShopify.helpers.displayStrikedPrice(
                      hit.price,
                      hit.compare_at_price
                    )}</span
                  ></span
                >
              `}
            ${!hit._distinct &&
              html`
                <span class="ais-hit--price-discount"
                  >${algoliaShopify.helpers.displayDiscount(
                    hit.price,
                    hit.compare_at_price,
                    hit.price_ratio
                  )}</span
                >
              `}
          </p>
          <!-- Extra info examples - Remove the display: none to show them -->
          <p class="ais-hit--info" style="display: none">
            ${hit.sku &&
              html`
                <span class="algolia-sku"
                  >${components.Highlight({ attribute: 'sku', hit })}</span
                >
              `}
            ${hit.barcode &&
              html`
                <span class="algolia-barcode"
                  >${components.Highlight({ attribute: 'barcode', hit })}</span
                >
              `}
            ${hit.weight &&
              html`
                <span class="algolia-weight">${hit.weight}</span>
              `}
            ${!hit.taxable &&
              html`
                <span class="algolia-taxable"
                  >${algoliaShopify.translations.taxFree}</span
                >
              `}
          </p>
          <!-- Tags example - Remove the display: none to show them -->
          <p class="ais-hit--tags" style="display: none">
            ${hit?._highlightResult.tags?.map(
              tag =>
                html`
                  <span class="ais-hit--tag">${tag.value}</span>
                `
            )}
          </p>
          ${!hit._distinct &&
            html`
              <form
                id="algolia-add-to-cart-${hit.objectID}"
                style="display: none;"
                action="/cart/add"
                method="post"
                enctype="multipart/form-data"
              >
                <input type="hidden" name="id" value="${hit.objectID}" />
              </form>
              <p class="ais-hit--cart">
                ${hit.can_order
                  ? html`
                      <button
                        class="ais-hit--cart-button"
                        data-form-id="algolia-add-to-cart-${hit.objectID}"
                      >
                        ${algoliaShopify.translations.addToCart}
                      </button>
                    `
                  : html`
                      <button
                        class="ais-hit--cart-button ais-hit--cart-button__disabled"
                      >
                        ${algoliaShopify.translations.outOfStock}
                      </button>
                    `}
              </p>
            `}
        </div>
      </div>
    `;
  });
  algoliaShopify.hooks.registerHook('beforeAutocompleteMainTemplate', function(_defaultTemplate, templateOptions, elements, displaySuggestions) {
    const { html } = templateOptions;
    // Don't return the default template and return a custom two-column layout instead
    return html`
      <div class="aa-PanelLayout aa-Panel--scrollable">
        <div class="aa-PanelSections">
          <div class="aa-PanelSection--left">
            ${displaySuggestions &&
              html`
                <div class="aa-SourceHeader">
                  <span class="aa-SourceHeaderTitle"
                    >${algoliaShopify.translations.suggestions}</span
                  >
                  <div class="aa-SourceHeaderLine" />
                </div>
                ${elements.querySuggestionsPlugin}
              `}
            ${elements.collections} ${elements.articles} ${elements.pages}
            ${elements.redirectUrlPlugin}
          </div>
          <div class="aa-PanelSection--right">
            ${elements.products}
          </div>
        </div>
      </div>
    `;
  });
  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteProductTemplate",
      function (_defaultTemplate, templateOptions, distinct, itemLink) {
        // Modify default options, then return them
        const { html, item, components } = templateOptions;
        let newin = null;
        if (item.meta.custom.new_prod == "newin") {
          newin = item.meta.custom.new_prod.substring(0, 3);
        } else {
          newin = null;
        }
        return html`
      <a
        href="${itemLink}"
        class="aa-ItemLink aa-ProductItem"
        onClick="${() => algoliaShopify.helpers.handleItemClick(item)}"
      >
        <div class="aa-ItemContent">
          <div class="aa-ItemPicture aa-ItemPicture--loaded">
            <div class="aa-image-overlay">
              <div class="news__badge">
                <span class="newin_elm">${newin}</span>
              </div>
              <div class="card__badge top left">
                <span class="aa-item--price-discount badge badge--bottom-left"
                  >${algoliaShopify.helpers.displayDiscount(
                    item.price,
                    item.compare_at_price,
                    item.price_ratio
                  ).replace("- ", "")}</span
                >
              </div>
            </div>
            <img
              src="${algoliaShopify.helpers.compactImage(item)}"
              alt="${item.title}"
            />
          </div>
          <div class="aa-ItemContentBody">
            <div class="prod_mat_tags">
              <p class="aa-ItemContentMeta prod_mat_tag">
                ${item.meta.custom.product_material_certifications}
              </p>
            </div>
            <div class="aa-ItemContentTitleWrapper">
              <div class="aa-ItemContentTitle">
                ${components.Highlight({ hit: item, attribute: "title" })}
                <span class="algolia-variant">
                  ${algoliaShopify.helpers.variantTitleAddition(item, distinct)}
                </span>
              </div>
            </div>
            <div class="aa-ItemContentPrice">
              <div class="aa-ItemContentPriceCurrent">
                ${algoliaShopify.helpers.displayPrice(item, distinct)}
              </div>
            </div>
          </div>
        </div>
      </a>
    `;
  });
});